/**
 * Homepage Trust Icons – infinite scroll
 * Measures the width of one full "set" (badges + dividers + gaps) so the loop is seamless.
 */
(function () {
  function measureScrollDistance(container) {
    var blockCount = parseInt(container.getAttribute('data-block-count'), 10) || 4;
    var items = container.querySelectorAll('.trust-icon-item');

    if (items.length < blockCount) return;

    // One set = first N badges and everything between them (dividers + 24px gaps each side).
    // Measuring from first badge left to last badge right includes all of that.
    var firstItem = items[0];
    var lastItemInSet = items[blockCount - 1];
    var firstLeft = firstItem.getBoundingClientRect().left;
    var lastRight = lastItemInSet.getBoundingClientRect().right;
    var setWidthPx = lastRight - firstLeft;

    container.style.setProperty('--trust-scroll-distance', setWidthPx + 'px');
  }

  function updateAllSections() {
    requestAnimationFrame(function () {
      var containers = document.querySelectorAll('.trust-icons-container[data-block-count]');
      for (var i = 0; i < containers.length; i++) {
        measureScrollDistance(containers[i]);
      }
    });
  }

  updateAllSections();
  window.addEventListener('resize', updateAllSections);
  window.addEventListener('load', updateAllSections);
})();
